function toSeconds(time_str: string): number {
  const parts: string[] = time_str.split(':');

  return Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2]);
}

export default toSeconds;
